import React from "react";
import { Trans } from "react-i18next";

import {
  Callout,
  Button,
  InputGroup,
  Tag,
  Dialog,
  Classes,
  FormGroup,
  Icon,
  Checkbox
} from "@blueprintjs/core";

import {
  Cell,
  Column,
  ColumnHeaderCell,
  RowHeaderCell,
  Table2
} from "@blueprintjs/table";

import {
  authenticatedGetFetch,
  authenticatedPostFetch,
  authenticatedDeleteFetch,
  authenticatedPutFetch
} from "../../../utils/AuthenticatedFetch";

export default class ServerTable extends React.Component {
  constructor() {
    super();
    this.state = {
      servers: [],
      creating: false,
      editing: -1
    };
  }

  componentDidMount() {
    this.updateTable();
  }

  updateTable() {
    authenticatedGetFetch('/servers', (response) => this.setState({ servers: response }));
  }

  render() {
    return <Callout title={<Trans>servers</Trans>}>
      <Button icon="add" onClick={() => this.setState({ creating: true })} />

      {/* creating dialog */}
      <Dialog
        style={{ transition: 'none' }}
        isOpen={this.state.creating}
        onClose={() => this.setState({ creating: false, creating_error: false })}
        title={<Trans>add a server</Trans>}
      >
        <div className={Classes.DIALOG_BODY}>
          <form onSubmit={e => {
            e.preventDefault(); // to avoid reload of the page on submit
            authenticatedPostFetch("/server", {
              name: this.state.input_name,
              ip: this.state.input_ip
            }, () => this.setState({ creating: false, creating_error: false }, () => this.updateTable()),
              () => this.setState({ creating_error: true }));
          }}>
            <FormGroup label={<Trans>label</Trans>} labelFor="input_name" inline={true}>
              <InputGroup id="input_name" intent={this.state.creating_error ? "danger" : "normal"}
                onChange={(ti) => this.setState({ input_name: ti.target.value })}
              />
            </FormGroup>

            <FormGroup label="IP" labelFor="input_ip" inline={true}>
              <InputGroup id="input_ip" intent={this.state.creating_error ? "danger" : "normal"}
                onChange={(ti) => this.setState({ input_ip: ti.target.value })}
              />
            </FormGroup>

            <Button
              text="OK"
              intent="primary"
              icon="add"
              type="submit"
            />
          </form>
        </div>
      </Dialog>

      {/* editing dialog */}
      <Dialog
        style={{ transition: 'none' }}
        isOpen={this.state.editing >= 0}
        onClose={() => this.setState({ editing: -1, creating_error: false })}
        title={<Trans>edit a server</Trans>}
      >
        <div className={Classes.DIALOG_BODY}>
          <form onSubmit={(e) => {
            e.preventDefault();
            authenticatedPutFetch("/server/" + this.state.servers[this.state.editing]["id"], {
              name: this.state.input_name,
              ip: this.state.input_ip,
              display: this.state.input_display
            }, () => this.setState({ editing: -1, creating_error: false }, () => this.updateTable()),
              () => this.setState({ creating_error: true }))
          }
          }>
            <FormGroup label={<Trans>name</Trans>} labelFor="input_name" inline={true}>
              <InputGroup id="input_name" intent={this.state.creating_error ? "danger" : "normal"}
                onChange={(ti) => this.setState({ input_name: ti.target.value })}
                value={this.state.input_name}
              />
            </FormGroup>
            <FormGroup label={<Trans>ip</Trans>} labelFor="input_ip" inline={true}>
              <InputGroup id="input_ip" intent={this.state.creating_error ? "danger" : "normal"}
                onChange={(ti) => this.setState({ input_ip: ti.target.value })}
                value={this.state.input_ip}
              />
            </FormGroup>
            <FormGroup label={<Trans>display</Trans>} 
              helperText="display on supervision page and envent flow"
              labelFor="input_display"
              inline={true}>
              <Checkbox id="input_display"
                onChange={(ti) => this.setState({ input_display: ti.target.checked })}
                checked={this.state.input_display}
              />
            </FormGroup>
            <Button
              text="OK"
              intent="primary"
              icon="edit"
              type="input"
            />
          </form>
        </div>
      </Dialog>

      <Table2
        cellRendererDependencies={[this.state.servers]}
        numRows={this.state.servers.length}
        rowHeaderCellRenderer={(rowIndex) => <RowHeaderCell index={rowIndex} name={this.state.servers[rowIndex]["id"]} />}
      >
        {/* label */}
        <Column
          id="label"
          cellRenderer={(rowIndex) => <Cell>{this.state.servers[rowIndex]["name"]}</Cell>}
          columnHeaderCellRenderer={() => <ColumnHeaderCell name={<Trans>label</Trans>} />}
        />

        {/* ip */}
        <Column
          id="label"
          cellRenderer={(rowIndex) => <Cell>{this.state.servers[rowIndex]["ip"]}</Cell>}
          columnHeaderCellRenderer={() => <ColumnHeaderCell name="IP" />}
        />

        {/* ip */}
        <Column
          id="visible"
          cellRenderer={(rowIndex) => <Cell>{this.state.servers[rowIndex]["display"] ? <Icon intent="success" icon="tick" /> : <Icon icon="cross" intent="danger" />}</Cell>}
          columnHeaderCellRenderer={() => <ColumnHeaderCell name={<Trans>display</Trans>} />}
        />

        {/* buttons */}
        <Column
          cellRenderer={(rowIndex) =>
            <Cell>
              <div className="flexbox-center">
                <Tag
                  icon="cog"
                  minimal={true}
                  interactive={true}
                  onClick={() => this.setState({
                    editing: rowIndex,
                    input_name: this.state.servers[rowIndex]["name"],
                    input_ip: this.state.servers[rowIndex]["ip"],
                    input_display: this.state.servers[rowIndex]["display"]
                  })}
                />
                <Tag
                  icon="trash" intent="danger"
                  minimal={true}
                  interactive={true}
                  onClick={() =>
                    authenticatedDeleteFetch("/server/" + this.state.servers[rowIndex]["id"], {
                      name: this.state.input_name,
                      ip: this.state.input_ip,
                    }, () => this.updateTable())
                  }
                />
              </div>
            </Cell>
          }
          columnHeaderCellRenderer={(index) => {
            return <ColumnHeaderCell index={index} />;
          }}
        />

      </Table2>
    </Callout>
  }
}